import CollectionBase from 'common/base/collection-base';

export default CollectionBase.extend({
  getEndTimestamp() {
    return this.getAttribute('endTimestamp');
  },

  getExtents(key, attributeName) {
    let attribute = attributeName;
    if (!attribute) {
      attribute = this.getAttributeName();
    }

    const results = this.getResults();
    let max = Number.MIN_VALUE;
    let min = Number.MAX_VALUE;
    for (let ii = 0, nn = results.length; ii < nn; ii++) {
      const result = results[ii];
      const reading = result[key];
      if (reading) {
        const value = reading[attribute];
        if (value > max) {
          max = value;
        }
        if (value < min) {
          min = value;
        }
      }
    }
    if (max === Number.MIN_VALUE) {
      max = 0;
    }
    if (min === Number.MAX_VALUE) {
      min = 0;
    }
    return {
      max,
      min,
    };
  },

  getStartTimestamp() {
    return this.getAttribute('startTimestamp');
  },

  hasResults(key) {
    const results = this.getResults();
    for (let ii = 0, nn = results.length; ii < nn; ii++) {
      const result = results[ii];
      if (result && result[key]) {
        return true;
      }
    }
  },
});
